import React from "react";
import theme from "../../../muiTheme";
import { useTranslation } from "react-i18next";
import "./StaticPromoBanner.scss";
import { Stack, Typography } from "@mui/material";
import ButtonElement from "../ButtonElement/ButtonElement";

interface StaticPromoBannerProps {
  text: string;
  btnText: string;
  secondary?: boolean;
  linkurl: string;
}

const StaticPromoBanner = ({ text, btnText, secondary, linkurl }: StaticPromoBannerProps) => {
  const { t } = useTranslation();

  const handleOpenHref = (href: string) => () => {
    window.open(href, '_blank');
  }

  return (
    <Stack
      sx={{
        width: "100%",
        borderRadius: "12px",
        background: 
          secondary === true
            ? theme.palette.background.promo2
            : theme.palette.background.promo1,
      }}
      direction={"row"}
    >
      <Stack
        direction={"column"}
        marginX={"1.5rem"}
        marginY={"1rem"}
        gap={"1rem"}
        justifyContent={"space-between"}
      >
        <Typography
          component="h2"
          variant="h2"
          color={theme.palette.background.default}
        >
          {t(`Promo.${text}`)}
        </Typography>
        <Stack width={"11rem"} className="promo-button">
          <ButtonElement onClick={handleOpenHref(linkurl)}>
            <Typography color={"white"}>{t(`Promo.${btnText}`)}</Typography>
          </ButtonElement>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default StaticPromoBanner;
